import { render, staticRenderFns } from "./integralList.vue?vue&type=template&id=55e954c6&scoped=true"
import script from "./integralList.vue?vue&type=script&lang=js"
export * from "./integralList.vue?vue&type=script&lang=js"
import style0 from "./integralList.vue?vue&type=style&index=0&id=55e954c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e954c6",
  null
  
)

export default component.exports